export enum BrandEnum {
    DaffodilCare = 1,
    Arcs = 2,
    MistyCroft = 3,
}